import React, { useContext, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@material-ui/core';
import PageContent from 'components/Generic/PageContent';
import { TableFilterContext, TableFilterContextInterface, TableFilterProvider } from 'tableFilterContext';
import { Routes } from 'routes';
import { transformObjectId } from 'services/apiPlatformTransformer';
import { AppContext } from 'context';
import Dialog from 'components/Dialog';
import { DialogWidth } from 'types';
import ExpeditionList from './ExpeditionList';
import { downloadExpeditions } from './services';
import { useStyles } from './index.styles';

const ExpeditionListPage: React.FC = () => {
  const { t } = useTranslation();
  const [downloadModalVisible, setDownloadModalVisible] = useState<boolean>(false);
  const classes = useStyles();
  const [isExportDisabled, setExportDisabled] = useState<boolean>(true);

  const context = useContext(AppContext);
  const sortingCenter = context.getSortingCenter?.();
  const sortingCenterId = transformObjectId(sortingCenter);

  const onExport = (tableFilters: TableFilterContextInterface) => {
    // Rebuild filters from tableFilter
    if (!sortingCenterId) return;
    const filters = tableFilters.search ? JSON.parse(atob(tableFilters.search)) : null;
    downloadExpeditions(sortingCenterId, filters ?? {}, t, setDownloadModalVisible);
  };

  return (
    <TableFilterProvider>
      <TableFilterContext.Consumer>
        {(tableFilters: TableFilterContextInterface) => (
          <PageContent
            title={t('expeditions.entityName')}
            actionButtonLink={{ pathname: Routes.ExpeditionCreate, state: { referer: Routes.Expeditions } }}
            noPadding
            exportButtonHandler={() => onExport(tableFilters)}
            exportButtonDisabled={isExportDisabled}
          >
            <Dialog
              closable={false}
              renderButton={() => {}}
              isOpen={downloadModalVisible}
              width={DialogWidth.SMALL_FORM}
              renderContent={() => (
                <>
                  <h1
                    style={{
                      fontWeight: 600,
                      fontSize: 24,
                    }}
                  >
                    {t('expeditions.exportPage.title')}
                  </h1>
                  <h2 className={classes.downloadModalSubtitle}>{t('expeditions.exportPage.subtitle')}</h2>
                  <CircularProgress style={{ marginBottom: 10 }} size={49} thickness={6} />
                </>
              )}
            />
            <ExpeditionList setExportDisabled={setExportDisabled} />
          </PageContent>
        )}
      </TableFilterContext.Consumer>
    </TableFilterProvider>
  );
};
export default ExpeditionListPage;
